import script from "./LinkPolymarket.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkPolymarket.vue?vue&type=script&setup=true&lang=js"

import "./LinkPolymarket.vue?vue&type=style&index=0&id=73529e6c&lang=scss"

const __exports__ = script;

export default __exports__